export default __webpack_public_path__ + "static/media/roe_grayscale.9fbac03c.svg";